import _slicedToArray from "/workspace/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import * as React from "react";
import { useSandpack } from "./useSandpack";
var FADE_DELAY = 1000; // 1 second delay one initial load, only relevant if the loading overlay is visible.

var FADE_ANIMATION_DURATION = 500; // 500 ms fade animation

export var useLoadingOverlayState = function useLoadingOverlayState(clientId) {
  var _useSandpack = useSandpack(),
      sandpack = _useSandpack.sandpack,
      listen = _useSandpack.listen;

  var _React$useState = React.useState("visible"),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      loadingOverlayState = _React$useState2[0],
      setLoadingOverlayState = _React$useState2[1];

  React.useEffect(function () {
    sandpack.loadingScreenRegisteredRef.current = true;
    var innerHook;
    var outerHook;
    var unsub = listen(function (message) {
      if (message.type === "start" && message.firstLoad === true) {
        setLoadingOverlayState("visible");
      }

      if (message.type === "done") {
        outerHook = setTimeout(function () {
          setLoadingOverlayState(function (prev) {
            return prev === "visible" ? "fading" : "hidden";
          } // Only set 'fading' if the current state is 'visible'
          );
          innerHook = setTimeout(function () {
            return setLoadingOverlayState("hidden");
          }, FADE_ANIMATION_DURATION);
        }, FADE_DELAY);
      }
    }, clientId);
    return function () {
      clearTimeout(outerHook);
      clearTimeout(innerHook);
      unsub();
    };
  }, []);

  if (sandpack.status === "timeout") {
    return "timeout";
  }

  if (sandpack.status !== "running") {
    return "hidden";
  }

  return loadingOverlayState;
};